/*
Monotype Foundry Platform API
Version 1.0.0

Definition: DeleteDropShipFilesRequest

Properties:
  fileIds: array (required)
*/

var DeleteDropShipFilesRequest = (function () {
  function validateDeleteDropShipFilesRequest (arg) {
    // Validate fileIds
    if (!arg.fileIds) {
      throw new Error('DeleteDropShipFilesRequest.fileIds: Missing property')
    }
    if (arg.fileIds && !(Array.isArray(arg.fileIds))) {
      throw new Error('DeleteDropShipFilesRequest.fileIds: Wrong type: Got \'' + (typeof arg.fileIds) + '\', but expected: \'array\'')
    }
  }
  function buildDeleteDropShipFilesRequest (arg) {
    var DeleteDropShipFilesRequest = arg
    // Complete fileIds
    // Expected Type: array
    DeleteDropShipFilesRequest.fileIds = DeleteDropShipFilesRequest.fileIds || []
    return DeleteDropShipFilesRequest
  }
  return {
    validate: validateDeleteDropShipFilesRequest,
    build: buildDeleteDropShipFilesRequest
  }
})()

module.exports = DeleteDropShipFilesRequest
